import Heading from '@atlaskit/heading';
import { Stack, Box, xcss } from '@atlaskit/primitives';
import AutoreviewIllustration from '@databases/icons/AutoreviewIllustration';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../../i18n';

const TableLayoutOptions: FunctionComponent = () => {
  const { formatMessage } = useIntl();
  return (
    <Stack alignBlock="center" alignInline="center">
      <Box
        xcss={xcss({
          width: '183px',
          textAlign: 'center',
        })}
      >
        <AutoreviewIllustration label="" />
        <Heading as="h4" size="small">
          {formatMessage(messages['view-settings.layout.table-options.empty-state-text'])}
        </Heading>
      </Box>
    </Stack>
  );
};

export default TableLayoutOptions;
